// extracted by mini-css-extract-plugin
export default {"App":"App_App__B2Ebb","item":"App_item__kkj2j","itemMobile":"App_itemMobile__T7pdr"};